exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tag--3pzJh{background:#e5e5e5;border-radius:2px;color:rgba(0,0,0,.6);padding:4px;display:flex;align-items:center}.tagTitle--1MFuy{text-transform:uppercase;letter-spacing:1px;font-weight:700;font-size:10px}.icon--2SWuP{font-size:12px;margin-left:5px;display:inline-block}", ""]);

// Exports
exports.locals = {
	"tag": "tag--3pzJh",
	"tagTitle": "tagTitle--1MFuy",
	"icon": "icon--2SWuP"
};